import {APP_INITIALIZER, ApplicationConfig, ErrorHandler} from '@angular/core';
import {provideRouter, Router} from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';

import * as Sentry from "@sentry/angular-ivy";

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
import {provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {provideAnimations} from "@angular/platform-browser/animations";
import {authInterceptor} from "./auth/auth.interceptor";
// register Swiper custom elements
register();

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withFetch(),withInterceptors([authInterceptor])),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
